import React from 'react'

import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

function ManutencaoUsuariosModal({ show, setShow, name1, name2, submit }) {

    const handleClose = () => setShow(false)

    return (
        <Modal centered backdrop="static" show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Unificação de Nomes</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p><b className='fs-6'>ATENÇÃO!</b></p>
                <p>
                    Você está prestes a unificar todos os registros de <br /><b>{name1}</b> em <b>{name2}</b>
                </p>

                <div>
                    <h6>Resultado da união:</h6>
                    <div className='d-flex justify-content-center'>
                        <span className='fs-6 badge bg-danger text-decoration-line-through'>{name1}</span>
                        <i className="bi bi-arrow-right mx-2"></i>
                        <span className='fs-6 badge bg-success'>{name2}</span>
                    </div>
                </div>

            </Modal.Body>
            <Modal.Footer>
                <Button variant="danger" className='fw-bold' onClick={submit}>
                    Confirmar
                </Button>
                <Button variant="secondary" onClick={handleClose}>
                    Cancelar
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default ManutencaoUsuariosModal